import React from "react";
import {Link} from 'react-router-dom';
import { useDispatch, useSelector} from 'react-redux';
import {getDetail} from '../acctions/index';
import { useEffect } from "react";
import s from '../css/detail.module.css'
import loading from '../image/loadingcan.gif'
import perritos from '../image/perritos.png'
import Error404 from "./Error404";


export default function Detail(props){
    console.log(props)
    const dispatch = useDispatch()

    useEffect(()=> {
        dispatch(getDetail(props.match.params.id));
    },[dispatch])

   const myDog = useSelector ((state) => state.detail)
   
   return(
    <div className={s.contenedor} > 
        <img className={s.perritos} src={perritos} />
        <img className={s.perritos2} src={perritos} />  
        {          
            myDog.length>0 ?
            <div className={s.conten2}>        
                <h2>{myDog[0].name}</h2>
                                                                                    
                {!myDog[0].image?<img className={s.image} src={'https://www.sogarca.com/wp-content/uploads/2015/06/No-disponible.jpg'}/>:<img alt="img not found" src={myDog[0].image}/>}
                <h3>Temperaments: </h3>
                <div className={s.divp}>
                <p>{
                    /* !myDog[0].createdInDb? */
                    myDog[0].temperaments +' '/* : */
                   /*  myDog[0].temperaments.map(el => el.name+(' , '))  */       
                  
                }</p>
                </div >
                   <ul className={s.lista}>
                        <li><h3 className={s.h3b}> Height:</h3></li>
                        <li><h3 className={s.h3b}> Weight:</h3></li>
                        <li><h3 className={s.h3b}> Life-Span:</h3></li>
                        <li className={s.h3b}>{myDog[0].height_Min} - {myDog[0].height_Max} Cm</li> 
                        <li> {myDog[0].weight_Min} - {myDog[0].weight_Max} Kg</li>
                        <li>
                        {isNaN(myDog[0].life_span)
                        ?myDog[0].life_span + ' '
                        :myDog[0].life_span + 'Years'}
                        </li>
                    </ul> 
                    <Link to='/home'>
                    <button className={s.btn3}>Return</button>
                    </Link>           
             </div>: <Error404/>

        }
          
    </div>
   )
}

